<template>
<v-dialog
  style="border-radius: 10px;"
  v-model="dialog"
  width="500"
>
  <v-card  class="px-2 py-3">
    <v-card-title class="pa-1">
      <span class="font-weight-bold headline wrld_subtitle--text">
        {{ $t('fleet.add_vehicle') }}
      </span>
    </v-card-title>
    <v-card-text class="pa-1">
      <v-container>
        <v-form v-model="isValid" ref="createVehicleForm">
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-text-field
              class="wrld_subtitle--text"
              :label="$t('fleet.name')"
              v-model="name"
              :rules="[Required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
                <v-select
                  :items="vehicleTypeList"
                  v-model="vehicleType"
                  :rules="[Required]"
                  :label="`${$t('fleet.type')}`"
                  :item-text="(item) => ($t(`fleet.${item.text}`))"
                  return-object
                ></v-select>
              </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
              class="wrld_subtitle--text"
              :label="`${$t('fleet.height')} (cm)`"
              v-model="vehicleHeight"
              :rules="[Required]"
              type="number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
              class="wrld_subtitle--text"
              :label="`${$t('fleet.width')}(cm)`"
              v-model="vehicleWidth"
              :rules="[Required]"
              type="number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
              class="wrld_subtitle--text"
              :label="`${$t('fleet.length')} (cm)`"
              v-model="vehicleLength"
              :rules="[Required]"
              type="number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
              class="wrld_subtitle--text"
              :label="`${$t('fleet.max_weight')} (kg)`"
              v-model="vehicleMaxWeight"
              :rules="[Required]"
              type="number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field
              class="wrld_subtitle--text"
              :label="$t('fleet.licence_plate')"
              v-model="plateNumber"
              :rules="[Required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
              class="wrld_subtitle--text"
              :label="$t('fleet.PerEmptyKM')"
              v-model="pricePerEmptyKM"
              :rules="[Required]"
              type="number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-select
                v-show="currenciesList != null"
                :items="currenciesList"
                v-model="currencyEmptyKM"
                :rules="[Required]"
                :label="`${$t('fleet.currency')}`"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="wrld-background elevation-1" @click="handleCancelVehicle"> <span color="wrld_subtitle--text">{{$t('buttons.cancel')}}</span> </v-btn>
      <v-btn v-if="!isLoadingAddingVehicle" color="accent elevation-1" class="ml-5 mr-4" :disabled="!isValid"  @click="handleCreateVehicle">{{$t('buttons.create')}}</v-btn>
      <v-btn v-else color="accent elevation-1" class="ml-5 mr-4" disabled>
        <v-progress-circular
          size="20"
          width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { vehicleService } from '@/_services'

export default {
  name: 'AddUser',
  props: {
    openMenu: { type: Boolean, default: false },
    orgID: { type: String, default: null }
  },
  data () {
    return {
      isLoadingAddingVehicle: false,
      dialog: false,
      isValid: false,
      name: null,
      vehicleHeight: null,
      vehicleWidth: null,
      vehicleLength: null,
      vehicleMaxWeight: null,
      plateNumber: null,
      vehicleType: null,
      pricePerEmptyKM: null,
      currencyEmptyKM: null,
      currenciesList: null,
      vehicleTypeList: []
    }
  },
  created() {
    vehicleService.getVehicleTypeEnum().then((response) => {
      this.vehicleTypeList = response.map(({ name }) => {
        return {
          text: name,
          value: name
         }
      })
    })
    vehicleService.getCurrencyEnum().then((response) => {
      this.currenciesList = response.map(({ name }) => {
        return name
      })
    })
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar',
      addSecondResourceOverviewListItem: 'addSecondResourceOverviewListItem'
    }),
    Required (value) {
      return !!value || this.$i18n.t('validations.required')
    },
    handleCreateVehicle () {
      this.isLoadingAddingVehicle = true
      vehicleService.createVehicle({
        organizationID: this.orgID === null ? this.$route.params.organizationID : this.orgID,
        name: this.name,
        type: this.vehicleType.value,
        vehicleHeight: this.vehicleHeight,
        vehicleWidth: this.vehicleWidth,
        vehicleLength: this.vehicleLength,
        vehicleMaxWeight: (Number(this.vehicleMaxWeight) * 1000),
        pricePerEmptyKM: this.pricePerEmptyKM,
        currencyEmptyKM: this.currencyEmptyKM,
        plateNumber: this.plateNumber
      }).then((response) => {
        this.addSecondResourceOverviewListItem({
          item: {
            id: response.id,
            objectID: response.id,
            name: this.name,
            labels: null,
            model: null,
            type: this.vehicleType.value,
            organization: {
              id: this.$route.params.organizationID,
              name: this.getSelectedResource.name
            },
            depot: null,
            loadArea: {
              maxWeight: null,
              width: null,
              height: null,
              length: null,
            },
            trailer: {
              maxWeight: null,
              width: null,
              height: null,
              length: null,
            },
            pricePerEmptyKM: {
              price: this.pricePerEmptyKM,
              currency: this.currencyEmptyKM
            },
            vehicleLimits: {
              maxWeight: (Number(this.vehicleMaxWeight) * 1000),
              width: this.vehicleWidth,
              height: this.vehicleHeight,
              length: this.vehicleLength,
            },
            plateNumber: this.plateNumber,
            equipment: null
          }
        })
        this.$nextTick(() => {
          this.dialog = false
          // this.$refs['createLocationForm'].reset()
        })
        this.showSnackbar({ message: this.$t('snackbars.vehicle_created'), color: 'success' })
      }).catch((error) => {
        this.showSnackbar({ message: this.$i18n.t('snackbars.error'), color: 'error' })
        console.error(error)
      }).finally(() => {
        this.isLoadingAddingVehicle = false
      })
    },
    handleCancelVehicle () {
      this.$refs['createVehicleForm'].reset()
      this.dialog = false
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedResource'
    ])
  },
  watch: {
    openMenu: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.dialog = val
      }
    },
    dialog: {
      deep: true,
      handler: function (val, oldVal) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
